import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom';
import Modal from 'bootstrap/js/dist/modal';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { getvendorsApi,getSiteItemApi } from '../../utils/ApiEndpointFunctions';
import { useUserContext } from '../../context/userContext';
import { getLocalizationStatus } from '../../utils/HelperFuncitons';
import { vendorTypeOptions } from '../../utils/constant';

function FilterReport(props) {
  const { modalId, formik, clickHandler, open, onClose } = props
  const [vendors, setVendors] = useState()
  const [items, setItems] = useState()
  const {langPreference} = useUserContext()
  const modalRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const element = document.getElementById(modalId);
    const modal = new Modal(element);
    modalRef.current = modal;
    const hidden = () => closeRef.current?.();
    element.addEventListener('hidden.bs.modal', hidden);
    return () => {
      element.removeEventListener('hidden.bs.modal', hidden);
      modal.hide();
      modal.dispose();
      modalRef.current = null;
    };
  }, [modalId]);

  useEffect(() => {
    if (open) modalRef.current?.show();
    else modalRef.current?.hide();
  }, [open]);

  const getVendors = async (type) => {
    try {
      const res = await getvendorsApi("","","",type)
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.vendors?.map(ele => ({ label: ele.name, value: ele }))
        setVendors(fetchedItem);
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getItems = async () => {
    try {
      const res = await getSiteItemApi()
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.data?.map(ele => ({ label: ele?._id, value: ele?.details }))
        setItems(fetchedItem);
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    // getVendors()
    getItems()
  }, [])

  const handleSelectDate = (e, type) => {
    formik.setFieldValue(type, e)
  };

  const handleVendorType =(e)=>{
    formik.setFieldValue("type",e?.value)
    formik.setFieldValue("vendorName","")
    formik.setFieldValue("vendorId", "")
  }
    useEffect(()=>{
    if(formik?.values?.type){
      setVendors([])
      getVendors(formik?.values?.type)
    }
    },[formik?.values?.type])
  
  return createPortal(
    <>
      <div
        className="modal"
        id={modalId}
        tabIndex="-1"
        aria-labelledby={`${modalId}-title`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-0">

              <button type="button" className="btn-close1" onClick={onClose} aria-label="Close"><i className="bi bi-x-lg"></i></button>
            </div>
            <div className="modal-body ">
              <div className="">
                <div className="bb">
                  <h5 id={`${modalId}-title`}>{langPreference?.filter || "Filter"}</h5>
                </div>
                <form className="my-fx" onSubmit={event => { event.preventDefault(); clickHandler(); }}>
                <div className="ed-box">
                    <label htmlFor="to" className="form-label">{langPreference?.date || "Date"} <span className='req-error'>*</span></label>
                    <DatePicker
                      selectsRange={true}
                      dateFormat="dd/MM/yyyy"
                      className={`form-control cursor-pointer ${((formik?.touched?.to && formik?.errors?.to)||(formik?.touched?.from && formik?.errors?.from)) && "border-danger"}`}
                      startDate={ formik.values?.to ? formik.values?.to :null }
                      endDate={formik.values?.from ?formik.values?.from :null}
                      // maxDate={new Date(new Date(formik.values?.to ? formik.values?.to : new Date()).setTime(new Date(formik.values?.to ? formik.values?.to : new Date()).getTime() + (1 * 1000 * 60 * 60 * 24 * 180)))}
                      onChange={(update) => {
                        handleSelectDate(update[0], "to")
                        handleSelectDate(update[1], "from")
                      }}
                      isClearable={true}
                      placeholderText={(langPreference?.from || 'from') + "-" + (langPreference?.to ||"to")}
                      showDisabledMonthNavigation
                    />
                    <div>
                     <div className='text-danger'>{(formik?.touched?.from && formik?.errors?.from) || (formik?.touched?.to && formik?.errors?.to)}</div>
                     {/* <div className='text-danger'>{formik?.touched?.from && formik?.errors?.from}</div> */}
                    </div>
                  </div>
                  <div className="ed-box">
                    <label htmlFor="reportType" className="form-label">{langPreference?.report_type || "Report type"} <span className='req-error'>*</span></label>
                    <select className={`form-select ${formik?.touched?.reportType && formik?.errors?.reportType && "border-danger"}`} name='reportType' aria-label="Default select example" value={formik?.values?.reportType} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="vendor">Vendor/Subcontractor</option>
                      <option value="item">Item</option>
                    </select>
                  </div>
                  <p className='text-danger'>{formik?.touched?.reportType && formik?.errors?.reportType}</p>
                  <div className="ed-box">
                    <label htmlFor="">{langPreference?.type ||"Type"}</label>
                    <div className='d-flex align-items-center justify-content-center mb-3 '>
                      <div className='cursor-pointer w-100' >
                        <Select style={{ cursor: "pointer !important" }} className='col w-100' placeholder={langPreference?.select || "Select type..."} cacheOptions value={formik?.values?.type ? {label:formik?.values?.type} : null} options={vendorTypeOptions} defaultOptions onChange={(e)=>{handleVendorType(e)}} />
                    </div>
                    </div>
                    {formik?.touched?.type && formik?.errors?.type ? (<div className='req-error'>{formik?.errors?.type}</div>) : null}
                  </div>
                  <div className="ed-box">
                    <label htmlFor="vendorId" className="form-label">{formik?.values?.type?.toLowerCase()=="vendor" ? langPreference?.vendor_name : langPreference?.subcontractor_name}</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={formik?.values?.vendorId}
                      placeholder={langPreference?.select || "Select"}
                      isSearchable={true}
                      name="vendorId"
                      options={vendors}
                      onChange={(e)=>formik.setFieldValue("vendorId", e) }
                    />
                  </div>

                  <div className="ed-box">
                    <label htmlFor="serialNumber" >{langPreference?.challan_po_voucher_number || "Challan/PO/Voucher Number"}</label>
                    <input type="serialNumber" className={`form-control ${formik?.touched?.serialNumber && formik?.errors?.serialNumber && "border-danger"}`} id="serialNumber" placeholder={langPreference?.enter_number || "Enter serial number"} name='serialNumber' value={formik?.values?.serialNumber} onChange={e => {e.target.value = e.target.value?.toUpperCase() ; formik?.handleChange(e)}} onBlur={formik?.handleBlur} />
                    <p className='text-danger'>{formik?.touched?.serialNumber && formik?.errors?.serialNumber}</p>
                  </div>

                  <div className="ed-box">
                    <label htmlFor="Item" className="form-label">{langPreference?.item || "Item"}</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={formik?.values?.itemName ? { label: formik?.values?.itemName,value:formik?.values?.itemName } : null}
                      placeholder={langPreference?.select || "Select"}
                      isSearchable={true}
                      name="itemName"
                      options={items}
                      onChange={(e) => {formik.setFieldValue("itemName", e.value?.name || "");formik.setFieldValue("uniqueItemId", e.value?.uniqueItemId || "") }}
                    />
                  </div>

                  <div className="ed-box">
                    <label htmlFor="status" className="form-label">{langPreference?.status || "Status"}</label>
                    <select className="form-select" name='status' aria-label="Default select example" value={formik?.values?.status} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="created">{getLocalizationStatus(langPreference,"Created")}</option>
                      <option value="submitted">{getLocalizationStatus(langPreference,"Submitted")}</option>
                      <option value="approved">{getLocalizationStatus(langPreference,"Approved")}</option>
                    </select>
                  </div>

                  <div className="d-flex mt-4 justify-content-end align-items-center">
                    <button type="submit" className="save border-0">
                      {langPreference?.apply || "Apply"}
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>, document.body
  )
}

export default FilterReport
